import React from 'react';
import { CheckIcon } from 'lucide-react';
import { differenceOneThings, youKnowItems } from '../data/content';
export function DifferenceSection() {
  return <section className="w-full bg-white px-5 py-12 sm:py-16" data-id="element-31" data-mp="1b41whyplm90j">
      <div className="mx-auto max-w-[960px]" data-id="element-32" data-mp="1p2jjtvbldjhx">
        <h2 className="text-balance text-center text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[2rem]" data-id="element-33" data-mp="1k2ne9rn8xk09">
          What Makes FINANCIAL LITERACY READY™ Different?
        </h2>

        <div className="mt-9 grid gap-10 md:grid-cols-2 md:gap-12" data-id="element-34" data-mp="1u1cxbnqvpai3">
          <div data-id="element-35" data-mp="1tz0hbg4ola7o">
            <p className="text-[1.05rem] leading-relaxed text-slate-950" data-id="element-36" data-mp="27ryjblbmq0k7">
              Most Financial Literacy resources give you
            </p>
            <ul className="mt-2 space-y-1" data-id="element-37" data-mp="22ug9zttp9jbo">
              {differenceOneThings.map(line => <li key={line} className="text-[1.05rem] text-slate-700 line-through decoration-slate-400" data-id="element-38" data-mp="2hr769u82uex2">
                  {line}
                </li>)}
            </ul>
            <p className="mt-5 text-[1.05rem] leading-relaxed text-slate-950" data-id="element-39" data-mp="2fu092b2sck5l">
              <strong className="font-extrabold" data-id="element-40" data-mp="2kr0fwo7glqxr">FINANCIAL LITERACY READY™</strong>{' '}
              is built differently.
            </p>
            <p className="mt-2 text-[1.3rem] font-extrabold uppercase leading-tight tracking-tight text-orange-700 sm:text-[1.5rem]" data-id="element-41" data-mp="2tr6phz01e6rn">
              It gives you an entire teaching SYSTEM.
            </p>
          </div>

          <div className="rounded-lg bg-slate-100 p-6" data-id="element-42" data-mp="33okw76w5rh6r">
            <p className="text-[0.95rem] font-bold text-slate-950" data-id="element-43" data-mp="33n9vxh1x8rke">You know:</p>
            <ul className="mt-3 space-y-2" data-id="element-44" data-mp="38h4ics8wvkn6">
              {youKnowItems.map(item => <li key={item} className="flex gap-2.5 text-[1rem] text-slate-950" data-id="element-45" data-mp="3ch4ziknea9xx">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-orange-700" strokeWidth={3} aria-hidden="true" data-id="element-46" data-mp="3mfuiyhuxw2ga" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-[640px] border-t border-slate-200 pt-6 text-center" data-id="element-47" data-mp="1w3e7atj4yijn">
          <p className="text-[1rem] font-bold text-slate-700" data-id="element-48" data-mp="1rd7lf1g0dc53">
            The goal is simple:
          </p>
          <p className="mt-2 text-balance text-[1.15rem] font-extrabold uppercase leading-tight tracking-tight text-slate-950 sm:text-[1.3rem]" data-id="element-49" data-mp="253t6mwsxpy65">
            Help you walk into every Financial Literacy class with a plan
            already prepared.
          </p>
        </div>
      </div>
    </section>;
}